import Pages from '@opsbase/lib-pages';
import App from '@opsbase/lib-system/App';
import { FeatureSets } from '@opsbase/lib-system/Features';
import FeatureStatus from '@opsbase/lib-system/FeatureStatus';
import SharedRoutes from '@opsbase/web-app/routes';
import PreviewPage from '@opsbase/web-opform-editor/Preview/PreviewPage';
import AssetCompareDialog from './dialogs/asset/AssetCompareDialog';
import AssetCreateDialog from './dialogs/asset/AssetCreateDialog';
import AssetDeleteDialog from './dialogs/asset/AssetDeleteDialog';
import AssetEditDialog from './dialogs/asset/AssetEditDialog';
import AssetMultiEditDialog from './dialogs/asset/AssetMultiEditDialog';
import { AssetTypeDeleteDialog } from './dialogs/asset/AssetTypeDeleteDialog';
import ConversationDialog from './dialogs/conversation/ConversationDialog';
import IssueCloseDialog from './dialogs/issue/IssueCloseDialog';
import IssueCreateDialog from './dialogs/issue/IssueCreateDialog';
import IssueEditDialog from './dialogs/issue/IssueEditDialog';
import IssueGenerateDetailsReportDialog from './dialogs/issue/IssueGenerateDetailsReportDialog';
import IssueMultiEditDialog from './dialogs/issue/IssueMultiEditDialog';
import IssueReassignDialog from './dialogs/issue/IssueReassignDialog';
import IssueReopenDialog from './dialogs/issue/IssueReopenDialog';
import IssuesAnalyseDialog from './dialogs/issue/IssuesAnalyseDialog';
import IssueTypeDeleteDialog from './dialogs/issue/IssueTypeDeleteDialog';
import OnboardingDialog from './dialogs/onboarding/onboarding.dialog';
import OpApproveDialog from './dialogs/op/OpApproveDialog';
import OpCancelDialog from './dialogs/op/OpCancelDialog';
import OpDeleteDialog from './dialogs/op/OpDeleteDialog';
import OpGenerateDetailsReportDialog from './dialogs/op/OpGenerateDetailsReportDialog';
import OpViewIssuesDialog from './dialogs/op/OpIssuesViewDialog';
import OpPerformDialog from './dialogs/op/OpPerformDialog';
import OpsAnalyseDialog from './dialogs/op/OpsAnalyseDialog';
import OpTypeDeleteDialog from './dialogs/op/OpTypeDeleteDialog';
import OpViewDialog from './dialogs/op/OpViewDialog';
import OpDefinitionAssignDialog from './dialogs/opdefinition/OpDefinitionAssignDialog';
import OpDefinitionCopyDialog from './dialogs/opdefinition/OpDefinitionCopyDialog';
import OpDefinitionCreateDialog from './dialogs/opdefinition/OpDefinitionCreateDialog';
import OpDefinitionDeleteDialog from './dialogs/opdefinition/OpDefinitionDeleteDialog';
import OpDefinitionDisableDialog from './dialogs/opdefinition/OpDefinitionDisableDialog';
import OpDefinitionEditDialog from './dialogs/opdefinition/OpDefinitionEditDialog';
import OpDefinitionEnableDialog from './dialogs/opdefinition/OpDefinitionEnableDialog';
import OpDefinitionMultiEditDialog from './dialogs/opdefinition/OpDefinitionMultiEditDialog';
import OpDefinitionPublishDialog from './dialogs/opdefinition/OpDefinitionPublishDialog';
import OpDefinitionRevertDialog from './dialogs/opdefinition/OpDefinitionRevertDialog';
import OrgTemplateCopyDialog from './dialogs/orgtemplates/OrgTemplateCopyDialog';
import OrgTemplateCreateDialog from './dialogs/orgtemplates/OrgTemplateCreateDialog';
import OrgTemplateDeleteDialog from './dialogs/orgtemplates/OrgTemplateDeleteDialog';
import OrgTemplateEditDialog from './dialogs/orgtemplates/OrgTemplateEditDialog';
import OrgTemplateRollOutDialog from './dialogs/orgtemplates/OrgTemplateRollOutDialog';
import PositionCreateDialog from './dialogs/position/PositionCreateDialog';
import PositionDeleteDialog from './dialogs/position/PositionDeleteDialog';
import PositionEditDialog from './dialogs/position/PositionEditDialog';
import QuestionSetCreateDialog from './dialogs/questionset/QuestionSetCreateDialog';
import QuestionSetDeleteDialog from './dialogs/questionset/QuestionSetDeleteDialog';
import QuestionSetEditDialog from './dialogs/questionset/QuestionSetEditDialog';
import QuestionSetPublishDialog from './dialogs/questionset/QuestionSetPublishDialog';
import ReportCreateDialog from './dialogs/report/ReportCreateDialog';
import ReportDeleteDialog from './dialogs/report/ReportDeleteDialog';
import ReportEditDialog from './dialogs/report/ReportEditDialog';
import StaffChangeEmailDialog from './dialogs/staff/StaffChangeEmailDialog';
import StaffCreateDialog from './dialogs/staff/StaffCreateDialog';
import StaffDeleteDialog from './dialogs/staff/StaffDeleteDialog';
import StaffDisableDialog from './dialogs/staff/StaffDisableDialog';
import StaffEditDialog from './dialogs/staff/StaffEditDialog';
import StaffEnableDialog from './dialogs/staff/StaffEnableDialog';
import StaffInviteDialog from './dialogs/staff/StaffInviteDialog';
import StaffMultiEditDialog from './dialogs/staff/StaffMultiEditDialog';
import TeamCreateDialog from './dialogs/team/TeamCreateDialog';
import TeamDeleteDialog from './dialogs/team/TeamDeleteDialog';
import TeamEditDialog from './dialogs/team/TeamEditDialog';
import TeamboardCreateDialog from './dialogs/teamboard/TeamboardCreateDialog';
import TeamboardDeleteDialog from './dialogs/teamboard/TeamboardDeleteDialog';
import TeamboardEditDialog from './dialogs/teamboard/TeamboardEditDialog';
import TeamboardMultiEditDialog from './dialogs/teamboard/TeamboardMultiEditDialog';
import WorkflowCreateDialog from './dialogs/workflow/WorkflowCreateDialog';
import WorkflowDeleteDialog from './dialogs/workflow/WorkflowDeleteDialog';
import WorkflowDisableDialog from './dialogs/workflow/WorkflowDisableDialog';
import WorkflowEditDialog from './dialogs/workflow/WorkflowEditDialog';
import WorkflowEnableDialog from './dialogs/workflow/WorkflowEnableDialog';
import WorkflowPickTriggerDialog from './dialogs/workflow/WorkflowPickTriggerDialog';
import AdvancedAssetTypesPage from './pages/AdvancedAssetTypesPage';
import AdvancedIntegrationsAPIPage from './pages/AdvancedIntegrationsAPIPage';
import AdvancedIntegrationsIoTPage from './pages/AdvancedIntegrationsIoTPage';
import AdvancedIntegrationsIQMPage from './pages/AdvancedIntegrationsIQMPage';
import AdvancedIssueFlagsPage from './pages/AdvancedIssueFlagsPage';
import AdvancedIssueReportingPage from './pages/AdvancedIssueReportingPage';
import AdvancedIssueTypesPage from './pages/AdvancedIssueTypesPage';
import AdvancedOpGradesPage from './pages/AdvancedOpGradesPage';
import AdvancedOpQuestionsPage from './pages/AdvancedOpQuestionsPage';
import AdvancedOpReportingPage from './pages/AdvancedOpReportingPage';
import AdvancedOpTemplatesPage from './pages/AdvancedOpTemplatesPage';
import AdvancedOpTypesPage from './pages/AdvancedOpTypesPage';
import AdvancedPositionsPage from './pages/AdvancedPositionsPage';
import AdvancedReportSettingsPage from './pages/AdvancedReportSettingsPage';
import AdvancedTeamsPage from './pages/AdvancedTeamsPage';
import AnalyticsDashboardPage from './pages/AnalyticsDashboardPage';
import AnalyticsIssuesPage from './pages/AnalyticsIssuesPage';
import AnalyticsOpsPage from './pages/AnalyticsOpsPage';
import AuthSwitchPage from './pages/auth/AuthSwitchPage';
import IssuesToDoPage from './pages/IssuesToDoPage';
import OpsBusinessRulesPage from './pages/OpsBusinessRulesPage';
import OpsOperationsPage from './pages/OpsOperationsPage';
import OpsToDoPage from './pages/OpsToDoPage';
import SetupPlacesPage from './pages/place/SetupPlacesPage';
import DashboardReportPage from './pages/public/dashboardreport/DashboardReportPage';
import DetailsReportPage from './pages/public/detailsreport/DetailsReportPage';
import ViewReportPage from './pages/public/viewreport/ViewReportPage';
import { SetupAssetCustomFieldsPage } from './pages/SetupAssetCustomFieldsPage';
import SetupAssetsPage from './pages/SetupAssetsPage';
import SetupStaffPage from './pages/SetupStaffPage';
import SetupTeamboardsPage from './pages/SetupTeamboardsPage';
export const getSpecialRouteFor = (self, realSelf) => {
    return realSelf.isSuperUser && !self.isOrgFocused ? Pages.AUTH_SWITCH : undefined;
};
const featureResolver = (f, features) => { var _a; return ((_a = features.find(z => z.name === f)) === null || _a === void 0 ? void 0 : _a.state) === FeatureStatus.ENABLED; };
export const defaultRouteFor = (self) => {
    if (featureResolver(FeatureSets[App.OPSBASE].TODO.key, self.features))
        return !self.isTeamboard ||
            featureResolver(FeatureSets[App.NATIVEBOARD].OPS.key, self.features)
            ? Pages.TODO_OPS
            : Pages.TODO_ISSUES;
    return Pages.OP_DEFINITIONS;
};
export const AppRoutes = [
    ...SharedRoutes,
    // --------
    // MISC
    // --------
    {
        flag: FeatureSets[App.OPSBASE].OPS_LOG.key,
        path: Pages.OP_PREVIEW,
        component: PreviewPage,
        componentType: 'standalone',
    },
    {
        path: Pages.PUBLIC_DETAILS_REPORT,
        component: DetailsReportPage,
        public: true,
    },
    {
        path: Pages.PUBLIC_LMSS_REPORT,
        component: ViewReportPage,
        public: true,
    },
    {
        path: Pages.PUBLIC_DASHBOARD_REPORT,
        component: DashboardReportPage,
        public: true,
    },
    {
        flag: FeatureSets[App.ADMINBASE].ORG_MANAGEMENT.key,
        path: Pages.AUTH_SWITCH,
        component: AuthSwitchPage,
        componentType: 'page',
    },
    // --------
    // TO DO
    // --------
    {
        flag: ((s, r) => r(FeatureSets[App.OPSBASE].TODO.key) &&
            (!s.isTeamboard || r(FeatureSets[App.NATIVEBOARD].OPS.key))),
        path: Pages.TODO_OPS,
        component: OpsToDoPage,
        componentType: 'page',
    },
    {
        flag: ((s, r) => r(FeatureSets[App.OPSBASE].TODO.key) &&
            (!s.isTeamboard || r(FeatureSets[App.NATIVEBOARD].ISSUES.key))),
        path: Pages.TODO_ISSUES,
        component: IssuesToDoPage,
        componentType: 'page',
    },
    // --------
    // OPERATIONS - BUSINESS OPERATIONS
    // --------
    {
        flag: FeatureSets[App.OPSBASE].OPS_MANAGEMENT.key,
        path: Pages.OP_DEFINITIONS,
        component: OpsOperationsPage,
        componentType: 'page',
    },
    // --------
    // OPERATIONS - BUSINESS RULES
    // --------
    {
        flag: FeatureSets[App.OPSBASE].WORKFLOW_MANAGEMENT.key,
        path: Pages.WORKFLOWS,
        component: OpsBusinessRulesPage,
        componentType: 'page',
    },
    // --------
    // ANALYTICS
    // --------
    {
        flag: FeatureSets[App.OPSBASE].DASHBOARD.key,
        path: Pages.DASHBOARD,
        component: AnalyticsDashboardPage,
        componentType: 'page',
    },
    {
        flag: FeatureSets[App.OPSBASE].OPS_LOG.key,
        path: Pages.OPS_LOG,
        component: AnalyticsOpsPage,
        componentType: 'page',
    },
    {
        flag: FeatureSets[App.OPSBASE].ISSUES_LOG.key,
        path: Pages.ISSUES_LOG,
        component: AnalyticsIssuesPage,
        componentType: 'page',
    },
    // --------
    //  SETUP -> PLACES
    // --------
    {
        flag: FeatureSets[App.OPSBASE].PLACES_MANAGEMENT.key,
        path: Pages.PLACES,
        component: SetupPlacesPage,
        componentType: 'page',
    },
    // --------
    // SETUP -> ASSETS
    // --------
    {
        flag: FeatureSets[App.OPSBASE].ASSET_MANAGEMENT.key,
        path: Pages.ASSETS,
        component: SetupAssetsPage,
        componentType: 'page',
    },
    {
        flag: FeatureSets[App.OPSBASE].ASSET_MANAGEMENT.key,
        path: Pages.ASSETCUSTOMFIELDS,
        component: SetupAssetCustomFieldsPage,
        componentType: 'page',
    },
    // --------
    // SETUP -> USERS
    // --------
    {
        flag: FeatureSets[App.OPSBASE].PEOPLE_MANAGEMENT.key,
        path: Pages.STAFF,
        component: SetupStaffPage,
        componentType: 'page',
    },
    {
        flag: FeatureSets[App.OPSBASE].TEAMBOARD_MANAGEMENT.key,
        path: Pages.TEAMBOARDS,
        component: SetupTeamboardsPage,
        componentType: 'page',
    },
    // ------------
    // SETUP - ADVANCED
    // ------------
    // USER SETTINGS
    {
        flag: FeatureSets[App.OPSBASE].PEOPLE_MANAGEMENT.key,
        path: Pages.TEAMS,
        component: AdvancedTeamsPage,
        componentType: 'page',
    },
    {
        flag: FeatureSets[App.OPSBASE].PEOPLE_MANAGEMENT.key,
        path: Pages.POSITIONS,
        component: AdvancedPositionsPage,
        componentType: 'page',
    },
    // OP SETTINGS
    {
        flag: FeatureSets[App.OPSBASE].QUESTIONBANK.key,
        path: Pages.QUESTION_SETS,
        component: AdvancedOpQuestionsPage,
        componentType: 'page',
    },
    {
        flag: FeatureSets[App.OPSBASE].QUESTIONBANK.key,
        path: Pages.QUESTION_SETS_EDIT,
        component: QuestionSetEditDialog,
        componentType: 'dialog',
    },
    {
        flag: FeatureSets[App.OPSBASE].QUESTIONBANK.key,
        path: Pages.QUESTION_SETS_CREATE,
        component: QuestionSetCreateDialog,
        componentType: 'dialog',
    },
    {
        flag: FeatureSets[App.OPSBASE].QUESTIONBANK.key,
        path: Pages.QUESTION_SETS_DELETE,
        component: QuestionSetDeleteDialog,
        componentType: 'dialog',
    },
    {
        flag: FeatureSets[App.OPSBASE].QUESTIONBANK.key,
        path: Pages.QUESTION_SETS_PUBLISH,
        component: QuestionSetPublishDialog,
        componentType: 'dialog',
    },
    {
        flag: FeatureSets[App.OPSBASE].ORG_SETTINGS.key,
        path: Pages.OPGRADESETTINGS,
        component: AdvancedOpGradesPage,
        componentType: 'page',
    },
    {
        flag: FeatureSets[App.OPSBASE].ORG_SETTINGS.key,
        path: Pages.OPTYPESETTINGS,
        component: AdvancedOpTypesPage,
        componentType: 'page',
    },
    {
        flag: FeatureSets[App.OPSBASE].ORG_SETTINGS.key,
        path: Pages.ORG_TEMPLATES,
        component: AdvancedOpTemplatesPage,
        componentType: 'page',
    },
    {
        flag: FeatureSets[App.OPSBASE].ORG_SETTINGS.key,
        path: Pages.ORG_TEMPLATE_CREATE,
        component: OrgTemplateCreateDialog,
        componentType: 'dialog',
    },
    {
        flag: FeatureSets[App.OPSBASE].ORG_SETTINGS.key,
        path: Pages.ORG_TEMPLATE_EDIT,
        component: OrgTemplateEditDialog,
        componentType: 'dialog',
    },
    {
        flag: FeatureSets[App.OPSBASE].ORG_SETTINGS.key,
        path: Pages.ORG_TEMPLATE_COPY,
        component: OrgTemplateCopyDialog,
        componentType: 'dialog',
    },
    {
        flag: FeatureSets[App.OPSBASE].ORG_SETTINGS.key,
        path: Pages.ORG_TEMPLATE_ROLLOUT,
        component: OrgTemplateRollOutDialog,
        componentType: 'dialog',
    },
    {
        flag: FeatureSets[App.OPSBASE].ORG_SETTINGS.key,
        path: Pages.ORG_TEMPLATE_DELETE,
        component: OrgTemplateDeleteDialog,
        componentType: 'dialog',
    },
    {
        flag: FeatureSets[App.OPSBASE].ORG_SETTINGS.key,
        path: Pages.OPREPORTSETTINGS,
        component: AdvancedOpReportingPage,
        componentType: 'page',
    },
    // ISSUE SETTINGS
    {
        flag: FeatureSets[App.OPSBASE].ORG_SETTINGS.key,
        path: Pages.ISSUETYPESETTINGS,
        component: AdvancedIssueTypesPage,
        componentType: 'page',
    },
    {
        flag: FeatureSets[App.OPSBASE].ORG_SETTINGS.key,
        path: Pages.ISSUEFLAGSETTINGS,
        component: AdvancedIssueFlagsPage,
        componentType: 'page',
    },
    {
        flag: FeatureSets[App.OPSBASE].ORG_SETTINGS.key,
        path: Pages.ISSUEREPORTSETTINGS,
        component: AdvancedIssueReportingPage,
        componentType: 'page',
    },
    // ASSET SETTINGS
    {
        flag: FeatureSets[App.OPSBASE].ASSET_MANAGEMENT.key,
        path: Pages.ASSETTYPESETTINGS,
        component: AdvancedAssetTypesPage,
        componentType: 'page',
    },
    // REPORT SETTINGS
    {
        flag: FeatureSets[App.OPSBASE].REPORT_MANAGEMENT.key,
        path: Pages.REPORTSETTINGS,
        component: AdvancedReportSettingsPage,
        componentType: 'page',
    },
    // INTEGRATIONS
    {
        flag: FeatureSets[App.OPSBASE].INTEGRATIONS_API.key,
        path: Pages.INTEGRATIONS_API,
        component: AdvancedIntegrationsAPIPage,
        componentType: 'page',
    },
    {
        flag: FeatureSets[App.OPSBASE].INTEGRATIONS_IOT.key,
        path: Pages.INTEGRATIONS_IOT,
        component: AdvancedIntegrationsIoTPage,
        componentType: 'page',
    },
    {
        flag: FeatureSets[App.OPSBASE].INTEGRATIONS_IQM.key,
        path: Pages.INTEGRATIONS_IQM,
        component: AdvancedIntegrationsIQMPage,
        componentType: 'page',
    },
    // --------
    // DIALOGS
    // --------
    // TO DO
    {
        flag: FeatureSets[App.OPSBASE].TODO.key,
        path: Pages.ISSUE_CREATE,
        component: IssueCreateDialog,
        componentType: 'dialog',
    },
    {
        flag: FeatureSets[App.OPSBASE].TODO.key,
        path: Pages.OP_PERFORM,
        component: OpPerformDialog,
        componentType: 'dialog',
    },
    // --------
    // CONVERSATION LOG
    // --------
    {
        flag: FeatureSets[App.OPSBASE].TODO.key,
        path: Pages.CONVERSATION_DETAILS,
        component: ConversationDialog,
        componentType: 'dialog',
    },
    {
        flag: FeatureSets[App.OPSBASE].TODO.key,
        path: Pages.CONVERSATION_DETAILS_NEW,
        component: ConversationDialog,
        componentType: 'dialog',
    },
    // --------
    // MANAGE OPERATIONS
    // --------
    {
        flag: FeatureSets[App.OPSBASE].OPS_MANAGEMENT.key,
        path: Pages.OP_DEFINITIONS,
        component: OpsOperationsPage,
        componentType: 'page',
    },
    {
        flag: FeatureSets[App.OPSBASE].OPS_MANAGEMENT.key,
        path: Pages.OP_DEFINITIONS_EDIT,
        component: OpDefinitionEditDialog,
        componentType: 'dialog',
    },
    {
        flag: FeatureSets[App.OPSBASE].OPS_MANAGEMENT.key,
        path: Pages.OP_DEFINITIONS_ASSIGN,
        component: OpDefinitionAssignDialog,
        componentType: 'dialog',
    },
    {
        flag: FeatureSets[App.OPSBASE].OPS_MANAGEMENT.key,
        path: Pages.OP_DEFINITIONS_COPY,
        component: OpDefinitionCopyDialog,
        componentType: 'dialog',
    },
    {
        flag: FeatureSets[App.OPSBASE].OPS_MANAGEMENT.key,
        path: Pages.OP_DEFINITIONS_DELETE,
        component: OpDefinitionDeleteDialog,
        componentType: 'dialog',
    },
    {
        flag: FeatureSets[App.OPSBASE].OPS_MANAGEMENT.key,
        path: Pages.OP_DEFINITIONS_PUBLISH,
        component: OpDefinitionPublishDialog,
        componentType: 'dialog',
    },
    {
        flag: FeatureSets[App.OPSBASE].OPS_MANAGEMENT.key,
        path: Pages.OP_DEFINITIONS_REVERT,
        component: OpDefinitionRevertDialog,
        componentType: 'dialog',
    },
    {
        flag: FeatureSets[App.OPSBASE].OPS_MANAGEMENT.key,
        path: Pages.OP_DEFINITIONS_DISABLE,
        component: OpDefinitionDisableDialog,
        componentType: 'dialog',
    },
    {
        flag: FeatureSets[App.OPSBASE].OPS_MANAGEMENT.key,
        path: Pages.OP_DEFINITIONS_MULTI_EDIT,
        component: OpDefinitionMultiEditDialog,
        componentType: 'dialog',
    },
    {
        flag: FeatureSets[App.OPSBASE].OPS_MANAGEMENT.key,
        path: Pages.OP_DEFINITIONS_ENABLE,
        component: OpDefinitionEnableDialog,
        componentType: 'dialog',
    },
    {
        flag: FeatureSets[App.OPSBASE].OPS_MANAGEMENT.key,
        path: Pages.OP_DEFINITIONS_CREATE,
        component: OpDefinitionCreateDialog,
        componentType: 'dialog',
    },
    // OPS
    {
        path: Pages.OP_VIEW,
        component: OpViewDialog,
        componentType: 'dialog',
    },
    {
        flag: FeatureSets[App.OPSBASE].OPS_LOG.key,
        path: Pages.OPS_LOG_DIALOG,
        component: OpsAnalyseDialog,
        componentType: 'dialog',
    },
    {
        path: Pages.OP_VIEW_ISSUES,
        component: OpViewIssuesDialog,
        componentType: 'dialog',
    },
    {
        path: Pages.OP_CANCEL,
        component: OpCancelDialog,
        componentType: 'dialog',
    },
    {
        path: Pages.OP_APPROVE,
        component: OpApproveDialog,
        componentType: 'dialog',
    },
    {
        path: Pages.OP_GENERATE_DETAILS_REPORT,
        component: OpGenerateDetailsReportDialog,
        componentType: 'dialog',
    },
    {
        flag: FeatureSets[App.OPSBASE].OPS_LOG.key,
        path: Pages.OP_DELETE,
        component: OpDeleteDialog,
        componentType: 'dialog',
    },
    // ISSUES
    {
        path: Pages.ISSUES_VIEW,
        component: IssueEditDialog,
        componentType: 'dialog',
    },
    {
        flag: FeatureSets[App.OPSBASE].ISSUES_LOG.key,
        path: Pages.ISSUES_LOG_DIALOG,
        component: IssuesAnalyseDialog,
        componentType: 'dialog',
    },
    {
        flag: FeatureSets[App.OPSBASE].TODO.key,
        path: Pages.ISSUES_CREATE,
        component: IssueCreateDialog,
        componentType: 'dialog',
    },
    {
        path: Pages.ISSUES_MULTI_EDIT,
        component: IssueMultiEditDialog,
        componentType: 'dialog',
    },
    {
        path: Pages.ISSUES_CLOSE,
        component: IssueCloseDialog,
        componentType: 'dialog',
    },
    {
        path: Pages.ISSUES_REOPEN,
        component: IssueReopenDialog,
        componentType: 'dialog',
    },
    {
        path: Pages.ISSUES_REASSIGN,
        component: IssueReassignDialog,
        componentType: 'dialog',
    },
    {
        path: Pages.ISSUE_GENERATE_DETAILS_REPORT,
        component: IssueGenerateDetailsReportDialog,
        componentType: 'dialog',
    },
    // STAFF
    {
        flag: FeatureSets[App.OPSBASE].PEOPLE_MANAGEMENT.key,
        path: Pages.STAFF_MULTI_EDIT,
        component: StaffMultiEditDialog,
        componentType: 'dialog',
    },
    {
        flag: FeatureSets[App.OPSBASE].PEOPLE_MANAGEMENT.key,
        path: Pages.STAFF_EDIT,
        component: StaffEditDialog,
        componentType: 'dialog',
    },
    {
        flag: FeatureSets[App.OPSBASE].PEOPLE_MANAGEMENT.key,
        path: Pages.STAFF_CREATE,
        component: StaffCreateDialog,
        componentType: 'dialog',
    },
    {
        flag: FeatureSets[App.OPSBASE].PEOPLE_MANAGEMENT.key,
        path: Pages.STAFF_DELETE,
        component: StaffDeleteDialog,
        componentType: 'dialog',
    },
    {
        flag: FeatureSets[App.OPSBASE].PEOPLE_MANAGEMENT.key,
        path: Pages.STAFF_INVITE,
        component: StaffInviteDialog,
        componentType: 'dialog',
    },
    {
        flag: FeatureSets[App.OPSBASE].PEOPLE_MANAGEMENT.key,
        path: Pages.STAFF_CHANGEEMAIL,
        component: StaffChangeEmailDialog,
        componentType: 'dialog',
    },
    {
        flag: FeatureSets[App.OPSBASE].PEOPLE_MANAGEMENT.key,
        path: Pages.STAFF_ENABLE,
        component: StaffEnableDialog,
        componentType: 'dialog',
    },
    {
        flag: FeatureSets[App.OPSBASE].PEOPLE_MANAGEMENT.key,
        path: Pages.STAFF_DISABLE,
        component: StaffDisableDialog,
        componentType: 'dialog',
    },
    // POSITIONS
    {
        flag: FeatureSets[App.OPSBASE].PEOPLE_MANAGEMENT.key,
        path: Pages.POSITIONS_CREATE,
        component: PositionCreateDialog,
        componentType: 'dialog',
    },
    {
        flag: FeatureSets[App.OPSBASE].PEOPLE_MANAGEMENT.key,
        path: Pages.POSITIONS_EDIT,
        component: PositionEditDialog,
        componentType: 'dialog',
    },
    {
        flag: FeatureSets[App.OPSBASE].PEOPLE_MANAGEMENT.key,
        path: Pages.POSITIONS_DELETE,
        component: PositionDeleteDialog,
        componentType: 'dialog',
    },
    // TEAMS
    {
        flag: FeatureSets[App.OPSBASE].PEOPLE_MANAGEMENT.key,
        path: Pages.TEAMS_CREATE,
        component: TeamCreateDialog,
        componentType: 'dialog',
    },
    {
        flag: FeatureSets[App.OPSBASE].PEOPLE_MANAGEMENT.key,
        path: Pages.TEAMS_DELETE,
        component: TeamDeleteDialog,
        componentType: 'dialog',
    },
    {
        flag: FeatureSets[App.OPSBASE].PEOPLE_MANAGEMENT.key,
        path: Pages.TEAMS_EDIT,
        component: TeamEditDialog,
        componentType: 'dialog',
    },
    // ASSETS
    {
        flag: FeatureSets[App.OPSBASE].ASSET_MANAGEMENT.key,
        path: Pages.ASSETS_MULTI_EDIT,
        component: AssetMultiEditDialog,
        componentType: 'dialog',
    },
    {
        flag: FeatureSets[App.OPSBASE].ASSET_MANAGEMENT.key,
        path: Pages.ASSETS_EDIT,
        component: AssetEditDialog,
        componentType: 'dialog',
    },
    {
        flag: FeatureSets[App.OPSBASE].ASSET_MANAGEMENT.key,
        path: Pages.ASSETS_DELETE,
        component: AssetDeleteDialog,
        componentType: 'dialog',
    },
    {
        flag: FeatureSets[App.OPSBASE].ASSET_MANAGEMENT.key,
        path: Pages.ASSETS_CREATE,
        component: AssetCreateDialog,
        componentType: 'dialog',
    },
    {
        flag: FeatureSets[App.OPSBASE].ASSET_MANAGEMENT.key,
        path: Pages.ASSETS_COMPARE,
        component: AssetCompareDialog,
        componentType: 'dialog',
    },
    // ON BOARDING
    {
        flag: FeatureSets[App.OPSBASE].ORG_SETTINGS.key,
        path: Pages.ONBOARDING,
        component: OnboardingDialog,
        componentType: 'dialog',
    },
    // WORKFLOWS
    {
        flag: FeatureSets[App.OPSBASE].WORKFLOW_MANAGEMENT.key,
        path: Pages.WORKFLOWS_EDIT,
        component: WorkflowEditDialog,
        componentType: 'dialog',
    },
    {
        flag: FeatureSets[App.OPSBASE].WORKFLOW_MANAGEMENT.key,
        path: Pages.WORKFLOWS_CREATE,
        component: WorkflowCreateDialog,
        componentType: 'dialog',
    },
    {
        flag: FeatureSets[App.OPSBASE].WORKFLOW_MANAGEMENT.key,
        path: Pages.WORKFLOWS_PICKTRIGGER,
        component: WorkflowPickTriggerDialog,
        componentType: 'dialog',
    },
    {
        flag: FeatureSets[App.OPSBASE].WORKFLOW_MANAGEMENT.key,
        path: Pages.WORKFLOWS_DELETE,
        component: WorkflowDeleteDialog,
        componentType: 'dialog',
    },
    {
        flag: FeatureSets[App.OPSBASE].WORKFLOW_MANAGEMENT.key,
        path: Pages.WORKFLOWS_DISABLE,
        component: WorkflowDisableDialog,
        componentType: 'dialog',
    },
    {
        flag: FeatureSets[App.OPSBASE].WORKFLOW_MANAGEMENT.key,
        path: Pages.WORKFLOWS_ENABLE,
        component: WorkflowEnableDialog,
        componentType: 'dialog',
    },
    // TEAMBOARDS
    {
        flag: FeatureSets[App.OPSBASE].TEAMBOARD_MANAGEMENT.key,
        path: Pages.TEAMBOARDS_MULTI_EDIT,
        component: TeamboardMultiEditDialog,
        componentType: 'dialog',
    },
    {
        flag: FeatureSets[App.OPSBASE].TEAMBOARD_MANAGEMENT.key,
        path: Pages.TEAMBOARDS_EDIT,
        component: TeamboardEditDialog,
        componentType: 'dialog',
    },
    {
        flag: FeatureSets[App.OPSBASE].TEAMBOARD_MANAGEMENT.key,
        path: Pages.TEAMBOARDS_DELETE,
        component: TeamboardDeleteDialog,
        componentType: 'dialog',
    },
    {
        flag: FeatureSets[App.OPSBASE].TEAMBOARD_MANAGEMENT.key,
        path: Pages.TEAMBOARDS_CREATE,
        component: TeamboardCreateDialog,
        componentType: 'dialog',
    },
    // REPORTS
    {
        flag: FeatureSets[App.OPSBASE].REPORT_MANAGEMENT.key,
        path: Pages.REPORT_EDIT,
        component: ReportEditDialog,
        componentType: 'dialog',
    },
    {
        flag: FeatureSets[App.OPSBASE].REPORT_MANAGEMENT.key,
        path: Pages.REPORT_DELETE,
        component: ReportDeleteDialog,
        componentType: 'dialog',
    },
    {
        flag: FeatureSets[App.OPSBASE].REPORT_MANAGEMENT.key,
        path: Pages.REPORT_CREATE,
        component: ReportCreateDialog,
        componentType: 'dialog',
    },
    {
        flag: FeatureSets[App.OPSBASE].ORG_SETTINGS.key,
        path: Pages.ASSET_TYPE_DELETE,
        component: AssetTypeDeleteDialog,
        componentType: 'dialog',
    },
    {
        flag: FeatureSets[App.OPSBASE].ORG_SETTINGS.key,
        path: Pages.ISSUE_TYPE_DELETE,
        component: IssueTypeDeleteDialog,
        componentType: 'dialog',
    },
    {
        flag: FeatureSets[App.OPSBASE].ORG_SETTINGS.key,
        path: Pages.OP_TYPE_DELETE,
        component: OpTypeDeleteDialog,
        componentType: 'dialog',
    },
];
